import clsx from 'clsx';
import { ReactNode } from 'react';

import { Button, Typography } from '@/shared/components/atoms';
import { TypographyProps } from '@/shared/components/atoms/Typography/Typography.types';

import Plus from '~/images/shared/Plus.svg';

const ActionTabHeader: React.FC<{
  title: string;
  description: string;
  actionTitle?: string;
  onClick?: () => void;
  titleTypography?: Omit<TypographyProps, 'children'>;
  descriptionTypography?: Omit<TypographyProps, 'children'>;
  disabled?: boolean;
  moreContent?: ReactNode;
  contentPlacment?: 'flex-row' | 'flex-row-reverse';
}> = ({
  title,
  description,
  actionTitle,
  onClick,
  titleTypography,
  descriptionTypography,
  disabled,
  moreContent,
  contentPlacment = 'flex-row',
}) => {
  return (
    <div className='flex flex-col items-start justify-between tablet:flex-row tablet:items-center'>
      <div className='mb-4'>
        <Typography {...titleTypography}>{title}</Typography>
        <Typography {...descriptionTypography}>{description}</Typography>
      </div>
      <div
        className={clsx(
          'flex w-full items-center gap-2 tablet:w-fit',
          contentPlacment
        )}
      >
        {actionTitle && onClick && (
          <Button
            disabled={disabled}
            onClick={onClick}
            size='full'
            className='flex w-full items-center justify-center gap-8 !rounded-xl py-2 px-16 tablet:w-fit'
          >
            <>
              <Plus />
              {actionTitle}
            </>
          </Button>
        )}
        {moreContent}
      </div>
    </div>
  );
};

ActionTabHeader.defaultProps = {
  titleTypography: {
    variant: 'h3',
    weight: 'semiBold',
  },
  descriptionTypography: {
    variant: 'subtitle2',
    className: 'mt-4 max-w-xl text-surface-10',
  },
};

export { ActionTabHeader };
